// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__2ofZv","menuIcon":"MenuItem_menuIcon__1aazE","activeIcon":"MenuItem_activeIcon__1OohP","inactiveIcon":"MenuItem_inactiveIcon__21IrD"};